import { z } from "zod";
import { memberCoreSchema } from "./memberCore.schemas";

export const visitSummarySchema = z.object({
	lastVisit: z.coerce.date().nullable(),
	memberVisitId: z.coerce.number().nullable(),
	countVisit: z.coerce.number().int().nonnegative(),
});

export const visitRecordDataSchema = memberCoreSchema
	.pick({
		memberId: true,
		memberCode: true,
		displayName: true,
		kakeruPoint: true,
		membershipStatus: true,
	})
	.merge(visitSummarySchema);

export const recordVisitResponseSchema = z.object({
	success: z.boolean(),
	duplicateVisit: z.boolean().default(false),
	pointsAwarded: z.boolean().default(false),
	message: z.string(),
	data: visitRecordDataSchema,
});

export const recordVisitByBarcodeMutationRequestSchema = z.object({
	memberCode: z.coerce.string().describe("Member barcode"),
	isMemberVisit: z.boolean().optional(),
});

export const recordVisitByQRCodeMutationRequestSchema = z.object({
	memberId: z.coerce.number().int().describe("Member ID"),
});

export const recordVisitByBarcode200Schema = recordVisitResponseSchema;

export const recordVisitByQRCode200Schema = recordVisitResponseSchema;

export const exportDailyVisitsQuerySchema = z.object({
	date: z.string().optional(),
});
